(function() {
  angular
    .module('cfn')
    .factory('personGroupCoreDataResolver', personGroupCoreDataResolver);

  personGroupCoreDataResolver.$inject = ['PersonGroup'];

  // resolve function bef
  function personGroupCoreDataResolver(PersonGroup) {
    return function() {
      return coreCommonResolveFunction(PersonGroup, true);
    };
  }
})();
